export const PROFILE_CHECKBOX_OPTIONS = [
  { id: "isManagerWithStaff", label: "Jag är chef med personalansvar" },
  { id: "worksInHR", label: "Jag arbetar med HR/personalfrågor" },
  { id: "hasUnionAssignment", label: "Jag har ett fackligt uppdrag" },
  { id: "isInsuranceRepresentative", label: "Jag är försäkringsinformatör" },
  { id: "isLocalPolitician", label: "Jag är politiker inom kommun eller region" },
  { id: "isStudent", label: "Jag är student" },
  { id: "isRetired", label: "Jag är pensionär" },
  { id: "isUnemployed", label: "Jag är arbetssökande" },
  { id: "isNonComputerWorker", label: "Jag arbetar sällan eller aldrig vid en dator" },
];
